/* ==========================================================================
   ViveZona — comportamiento de la ficha
   - revelado al hacer scroll (una vez por elemento)
   - barra fija de compra (aparece al pasar el botón y se esconde en el pie)
   - pausa los videos que no se ven
   - acordeón de preguntas
   - fecha de entrega estimada
   - botón de pago contra entrega y oferta por cantidad, con la casa encima
   ========================================================================== */

(function () {
  "use strict";

  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  var observadorDom = null;
  var observadorEstilo = null;
  var vigilanteVideos = null;

  var MESES = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
  ];

  /* ---------- revelado al hacer scroll ---------- */

  function initReveal() {
    var items = document.querySelectorAll(".vz-r:not(.is-in)");
    if (!items.length) return;

    if (reduce.matches || !("IntersectionObserver" in window)) {
      items.forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- barra fija de compra ---------- */

  function initSticky() {
    var bar = document.querySelector(".vz-sticky");
    if (!bar) return;

    var form = bar.querySelector("form");
    var centinela =
      document.querySelector(".product-form-buttons") ||
      document.querySelector("#es-popup-button") ||
      document.querySelector("#ProductSubmitButton");
    var pie = document.querySelector("footer") || document.querySelector('[id*="footer"]');
    var programado = false;

    /* el botón de la barra abre el mismo formulario de pago contra entrega */
    if (form) {
      form.addEventListener("submit", function (evento) {
        var cod = document.getElementById("es-popup-button");
        if (!cod) return; /* sin app: se envía el formulario normal */
        evento.preventDefault();
        cod.click();
      });
    }

    function calcular() {
      programado = false;

      var visible = false;
      if (centinela) {
        visible = centinela.getBoundingClientRect().bottom < 0;
      }
      if (visible && pie) {
        /* se esconde en cuanto asoma el pie para no taparlo */
        visible = pie.getBoundingClientRect().top > window.innerHeight * 0.85;
      }

      bar.classList.toggle("is-visible", visible);
      if (!form) return;
      var controles = form.querySelectorAll("input, button");
      for (var i = 0; i < controles.length; i++) {
        controles[i].disabled = !visible;
      }
    }

    function alDesplazar() {
      if (programado) return;
      programado = true;
      requestAnimationFrame(calcular);
    }

    /* Horizon desplaza dentro de .page-wrapper, así que se escucha en captura */
    document.addEventListener("scroll", alDesplazar, { passive: true, capture: true });
    window.addEventListener("resize", alDesplazar);
    calcular();
  }

  /* ---------- videos: solo se reproduce el que se ve ---------- */

  function engancharVideos() {
    if (!vigilanteVideos) return;
    document.querySelectorAll("video:not([data-vz-video])").forEach(function (video) {
      video.setAttribute("data-vz-video", "1");
      vigilanteVideos.observe(video);
    });
  }

  function initVideos() {
    if (!("IntersectionObserver" in window)) return;

    vigilanteVideos = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            var reproduciendo = video.play();
            if (reproduciendo && reproduciendo.catch) reproduciendo.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.35, 0.75] }
    );

    engancharVideos();
  }

  /* ---------- acordeón de preguntas ---------- */

  function initFaq() {
    document.querySelectorAll(".vz-faq__item").forEach(function (item) {
      var boton = item.querySelector(".vz-faq__q");
      var panel = item.querySelector(".vz-faq__a");
      if (!boton || !panel) return;

      boton.setAttribute("aria-expanded", "false");
      panel.inert = true;

      boton.addEventListener("click", function () {
        var abierto = item.classList.toggle("is-open");
        boton.setAttribute("aria-expanded", abierto ? "true" : "false");
        panel.inert = !abierto;
      });
    });
  }

  /* ---------- fecha de entrega estimada ---------- */

  function sumarDiasHabiles(desde, cantidad) {
    var d = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate());
    var sumados = 0;
    while (sumados < cantidad) {
      d.setDate(d.getDate() + 1);
      var dia = d.getDay();
      if (dia !== 0 && dia !== 6) sumados++;
    }
    return d;
  }

  function initFechaEntrega() {
    var destinos = document.querySelectorAll("[data-vz-eta]");
    if (!destinos.length) return;

    /* despacho 1-2 días hábiles + entrega 3-7 días hábiles = 4 a 9 */
    var ahora = new Date();
    var corrimiento = ahora.getHours() >= 14 ? 1 : 0;
    var desde = sumarDiasHabiles(ahora, corrimiento + 4);
    var hasta = sumarDiasHabiles(ahora, corrimiento + 9);

    var texto;
    if (desde.getMonth() === hasta.getMonth()) {
      texto = "entre el " + desde.getDate() + " y el " + hasta.getDate() + " de " + MESES[hasta.getMonth()];
    } else {
      texto =
        "entre el " + desde.getDate() + " de " + MESES[desde.getMonth()] +
        " y el " + hasta.getDate() + " de " + MESES[hasta.getMonth()];
    }

    destinos.forEach(function (el) {
      el.textContent = texto;
    });
  }

  /* ---------- formulario y oferta de la app ---------- */

  /* La app define el look de su formulario con estilos en línea y !important.
     Se quitan solo las propiedades cosméticas: lo funcional (display, tamaño,
     posición) se respeta. Solo se escribe cuando algo cambió, para no
     despertar al observador de atributos en vano. */
  var PROPIEDADES_APP = [
    "color", "background", "background-color", "background-image",
    "border-color", "border-radius",
    "font-size", "font-weight", "font-style", "letter-spacing",
  ];

  function limpiarModalApp() {
    var modal = document.getElementById("easysell-modal");
    if (!modal) return;

    modal.querySelectorAll("[style]").forEach(function (el) {
      /* la máscara de carga se pinta con fondo propio */
      if ((el.className || "").toString().indexOf("loading") !== -1) return;

      PROPIEDADES_APP.forEach(function (propiedad) {
        if (el.style.getPropertyValue(propiedad)) el.style.removeProperty(propiedad);
      });
      if (!el.getAttribute("style")) el.removeAttribute("style");
    });

    /* "Ahorra 0%" en el frasco suelto no dice nada */
    modal.querySelectorAll(".es-offer-badge").forEach(function (insignia) {
      if (insignia.style.display === "none") return;
      if (/^ahorra\s*0\s*%/i.test(insignia.textContent.trim())) {
        insignia.style.display = "none";
      }
    });
  }

  /* El aviso del pack sale solo si la app trae de verdad un escalón de 2+
     frascos, y los montos se copian de lo que la app ya escribe: así nunca se
     anuncia un precio que el formulario no cobre. */
  function initAvisoPack() {
    var caja = document.querySelector("[data-vz-oferta]");
    if (!caja || caja.classList.contains("is-on")) return;

    var huecoPrecio = caja.querySelector("[data-vz-oferta-precio]");
    var huecoAntes = caja.querySelector("[data-vz-oferta-antes]");
    var huecoBase = caja.querySelector("[data-vz-oferta-base]");
    var huecoAhorro = caja.querySelector("[data-vz-oferta-ahorro]");
    var intentos = 0;

    function texto(el) {
      return el ? el.textContent.trim() : "";
    }

    function buscarTarjeta(tarjetas, escalon) {
      var buscado = texto(escalon.title ? { textContent: escalon.title } : null).toLowerCase();
      var encontrada = null;
      tarjetas.forEach(function (tarjeta) {
        if (encontrada) return;
        if (buscado && texto(tarjeta.querySelector(".mb-1")).toLowerCase() !== buscado) return;
        encontrada = tarjeta;
      });
      return encontrada;
    }

    function mirar() {
      var lista = window.EASYSELL_QUANTITY_OFFERS;
      var escalones = [];

      if (Array.isArray(lista)) {
        lista.forEach(function (oferta) {
          if (!oferta || !oferta.offers) return;
          oferta.offers.forEach(function (escalon) {
            if (escalon && Number(escalon.quantity) > 0) escalones.push(escalon);
          });
        });
      }

      var pack = null;
      escalones.forEach(function (escalon) {
        if (Number(escalon.quantity) < 2) return;
        if (!pack || Number(escalon.quantity) < Number(pack.quantity)) pack = escalon;
      });

      var tarjetas = document.querySelectorAll("#es-form .es-qo-container");
      var tarjetaPack = pack ? buscarTarjeta(tarjetas, pack) : null;

      if (!pack || !tarjetaPack || !tarjetas.length) {
        if (++intentos < 24) setTimeout(mirar, 500);
        return;
      }

      if (huecoPrecio) huecoPrecio.textContent = texto(tarjetaPack.querySelector(".es-o-p"));
      if (huecoAhorro) huecoAhorro.textContent = texto(tarjetaPack.querySelector(".es-offer-badge"));

      if (huecoAntes) {
        var antes = texto(tarjetaPack.querySelector(".es-o-cp"));
        huecoAntes.textContent = antes;
        huecoAntes.hidden = !antes;
      }
      if (huecoBase) {
        huecoBase.textContent = texto(tarjetas[0].querySelector(".es-o-p"));
      }

      caja.classList.add("is-on");
    }

    mirar();
  }

  /* ---------- botón de pago contra entrega ---------- */

  /* escribe solo si de verdad cambia: el observador de DOM escucha el cambio
     y volver a escribir el mismo texto dispararía un bucle sin fin */
  function corregirTexto(el, original, nuevo) {
    if (!el) return;
    var actual = el.textContent.trim();
    if (actual === nuevo || !original.test(actual)) return;
    el.textContent = nuevo;
  }

  function pintarBotonContraEntrega() {
    /* la app repite el mismo id en cada tarjeta y en el carrito */
    var botones = document.querySelectorAll("#es-popup-button");
    if (!botones.length) return;

    /* la app escribe los colores en línea con !important: solo se puede
       corregir desde el propio elemento */
    var casa = {
      background: "rgb(31, 77, 54)",
      "border-radius": "4px",
      "font-weight": "600",
      "font-size": "0.84rem",
      "letter-spacing": "0.1em",
    };

    botones.forEach(function (boton) {
      /* el navegador normaliza #1f4d36 a rgb(31, 77, 54): comparar contra el
         hex daría "distinto" siempre y el observador de atributos entraría en
         bucle. Por eso se mide el color ya aplicado. */
      var yaPintado =
        boton.dataset.vzCod === "1" &&
        window.getComputedStyle(boton).backgroundColor === "rgb(31, 77, 54)";

      if (!yaPintado) {
        Object.keys(casa).forEach(function (propiedad) {
          boton.style.setProperty(propiedad, casa[propiedad], "important");
        });
        boton.dataset.vzCod = "1";
      }

      /* solo corrige los textos que siguen como vinieron de fábrica: si mañana
         los cambias en la app, esto deja de aplicar */
      corregirTexto(boton.querySelector(".es-button-title"), /^paga al recibir\.?$/i, "Paga al recibir");
      corregirTexto(boton.querySelector(".es-button-subtitle"), /^env[ií]o gratuito!?$/i, "Despacho incluido");
    });
  }

  /* ---------- observadores ---------- */

  function initObservadores() {
    if (observadorDom || !("MutationObserver" in window)) return;

    observadorDom = new MutationObserver(function () {
      engancharVideos();
      pintarBotonContraEntrega();
      limpiarModalApp();
    });
    observadorDom.observe(document.body, { childList: true, subtree: true });

    /* la app reescribe sus estilos al cambiar de opción */
    observadorEstilo = new MutationObserver(function () {
      limpiarModalApp();
      pintarBotonContraEntrega();
    });
    observadorEstilo.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
      subtree: true,
    });
  }

  /* ---------- arranque ---------- */

  function boot() {
    initReveal();
    initSticky();
    initVideos();
    initFaq();
    initFechaEntrega();
    initAvisoPack();
    pintarBotonContraEntrega();
    limpiarModalApp();
    initObservadores();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Shopify puede reemplazar secciones sin recargar */
  document.addEventListener("shopify:section:load", boot);

  if (reduce.addEventListener) {
    reduce.addEventListener("change", function (e) {
      if (e.matches) initReveal();
    });
  }
})();
